exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.otp-input {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 10px 0;\n}\n.otp-input input {\n  width: 100%;\n  height: 50px;\n  margin: 0 5px;\n  font-size: 30px;\n  outline: 0;\n  border-width: 0 0 2px;\n  border-color: #e3eaed;\n  color: #005ba5;\n  text-align: center;\n}\n.otp-input input:focus {\n  border-color: #005ba5;\n}\n.otp-focus {\n  border-color: #005ba5;\n}", ""]);

// exports
